export const tabItems = {
  payslips: 'payslips',
  compensation: 'compensation',
  form16: 'form16',
};

export const compensationTabItems = {
  ctc: 'ctc',
  bonus: 'bonus',
  deductions: 'deductions',
  perquisites: 'perquisites',
  flexi: 'flexi',
};

export const queryKeys = {
  FETCH_USER_DETAILS: 'FETCH_USER_DETAILS',
  FETCH_COMPENSATION_DETAILS: 'FETCH_COMPENSATION_DETAILS',
  FETCH_LIST_DEDUCTIONS: 'FETCH_LIST_DEDUCTIONS',
  FETCH_VPF_DETAILS: 'FETCH_VPF_DETAILS',
  FETCH_EMPLOYEE_TAX_REGIME: 'FETCH_EMPLOYEE_TAX_REGIME',
};

export const DEDUCTION_TYPE_RECURRING = 'RECURRING';

export const statutoryComponentNameMap = {
  pf: 'Employer PF Contribution',
  esi: 'Employer ESI Contribution',
  vpf: 'Employer VPF Contribution',
  lwf: 'Employer LWF Contribution',
};

export const links = {
  learnMoreAboutVpf: 'https://razorpay.com/docs/payroll/voluntary-provident-fund/',
};

export const EMPLOYER_NPS_COMPONENT_NAME = 'Employer NPS';

export const BONUS_HELP_ARTICLE_URL =
  'https://intercom.help/XPayroll/en/articles/8320127-how-do-i-create-an-employee-bonus';
export const PAYROLL_MONTH_HELP_TEXT =
  "TDS is deducted in this month's payroll. If payroll isn't run for this month, it isn't deducted at all.";

export const PAYROLL_MONTH_CHECKING_TEXT = 'Checking payroll status for this month...';

export const TAX_DEDUCTION_BEHAVIOUR = {
  INSTANT: 'instant',
  PRO_RATED: 'pro_rated',
} as const;

export const TDS_DEDUCTION_LABEL = {
  [TAX_DEDUCTION_BEHAVIOUR.INSTANT]: 'Instant',
  [TAX_DEDUCTION_BEHAVIOUR.PRO_RATED]: 'Pro-rated',
} as const;

export const PRO_RATED_TDS_CAPTION = 'Across the year';
